import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useContext, useEffect, useRef, useState } from "react";
import PoliticalPartyService from "../../services/PoliticalPartyService";
import { Button } from "primereact/button";
import { APP_TYPE, formatDate } from "../../config/Config";
import DocumentTypesService from "../../services/DocumentsService";
import { helper } from "../../componets/utils/helper";
import { candidateService } from "../../services/CandidateService";
import ScreenLoader from "../../componets/ScreenLoader";
import { AppDB } from "../../App";
import { PoliticalPartyDBContext } from "./PoliticalPartyDBContext";
import GenericFileCapture from "../../componets/GenericFileCapture";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

export default function ({ showAddDialog, setShowAddDialog, header = "Proportional Candidates Documents ", delimitation, setDelimitation }) {
	var { selectedParty } = useContext(PoliticalPartyDBContext);
	var { lookUp } = useContext(AppDB);
	var [showFileUploader, setShowFileUploader] = useState(false);
	var [fileUploaderDocuments, setFileUploaderDocuments] = useState([]);
	var [loading, setLoading] = useState(false);
	var [refresh, setRefresh] = useState(true);
	var [documents, setDocuments] = useState([]);
	var { toast } = useContext(AppDB);
	var [politicalDocumentTypes, setPoliticalDocuments] = useState([]);

	var political = new PoliticalPartyService();
	var doc = new DocumentTypesService();

	useEffect(() => {
		doc.getDocumentTypes(1).then((res) => {
			setPoliticalDocuments(res);
		});
	}, []);

	useEffect(() => {
		if (selectedParty?.politicalPartyID) {
			setLoading(true);
			political.getDocumentsByParty(selectedParty.politicalPartyID).then((res) => {
				setDocuments(res.documents);
				setLoading(false);
			});
		}
	}, [refresh, showAddDialog]);
	var convertBase64 = (file) => {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);
			fileReader.onload = () => {
				resolve(fileReader.result);
			};
			fileReader.onerror = (error) => {
				reject(error);
			};
		});
	};

	const confirmDelete = (e, row) => {
		confirmDialog({
			target: e.currentTarget,
			message: "Are you sure you want to proceed?",
			icon: "pi pi-exclamation-triangle",
			accept: () => {
				setLoading(true);
				political.deletePartyDocuments(row.documentID).then((res) => {
					setLoading(false);
					if (res.success) {
						setRefresh(!refresh);
						toast.show({
							severity: "success",
							detail: "Document Deleted",
							life: 2500
						});
					} else {
						toast.show({
							severity: "error",
							detail: res.message,
							life: 2500
						});
					}
				});
			},
			reject: () => {}
		});
	};

	return (
		<>
			<ScreenLoader visible={loading} />
			<ConfirmDialog />
			{APP_TYPE !== "PoliticalParty" && (
				<div className="card">
					<div className="col-12  lg:col-3 my-2">
						<>
							<Button
								disabled={[null, undefined, ""].includes(selectedParty?.politicalPartyID)}
								label={"Upload"}
								onClick={() => setShowFileUploader(true)}
								className="p-button-success"
								icon={"pi pi-plus"}
							/>
						</>
					</div>
				</div>
			)}

			<GenericFileCapture
				refresh={refresh}
				setRefresh={setRefresh}
				requestCall={political.createDocuments}
				param={{ politicalPartyID: selectedParty.politicalPartyID }}
				key={JSON.stringify(showAddDialog) + JSON.stringify(JSON.stringify(showAddDialog))}
				extraAttributes={{
					politicalPartyID: selectedParty?.politicalPartyID
				}}
				documentTypesLookUp={politicalDocumentTypes}
				show={showFileUploader}
				setShow={setShowFileUploader}
				setDocuments={setFileUploaderDocuments}
				documents={fileUploaderDocuments}
			/>

			<DataTable
				className="remove-border"
				size="small"
				scrollable={true}
				value={documents}
				dataKey="id"
				loading={loading}
				responsiveLayout="scroll"
				style={{ width: "100%" }}
			>
				<Column header={"Title"} field="title"></Column>
				<Column header={"Document Type"} field="documentType"></Column>
				<Column header={"Created Date"} body={(row) => formatDate(row.createdDate)}></Column>
				<Column
					header={"Action"}
					field="Action"
					body={(row) => (
						<>
							<Button
								style={{
									textAlign: "center",
									width: "30px",
									height: "30px"
								}}
								icon={"pi pi-download"}
								tooltipOptions={{ position: "top" }}
								className="p-button-primary p-button-rounded mr-2"
								tooltip="Click to download"
								onClick={(e) => {
									e.stopPropagation();
									setLoading(true);
									doc.downloadDocument(row.documentID).then((res) => {
										setLoading(false);
									});
								}}
							/>
							{APP_TYPE === "Central" && (
								<Button
									onClick={(ee) => confirmDelete(ee, row)}
									style={{ textAlign: "center", width: "30px", height: "30px" }}
									icon={"pi pi-trash"}
									className="p-button-danger p-button-rounded mr-2"
									tooltip="Click to delete"
								/>
							)}
						</>
					)}
				></Column>
			</DataTable>
		</>
	);
}
